// components/AuthModal.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser, registerUser } from '../services/api';
import '../styles/AuthModal.css';

const AuthModal = ({ isOpen, onClose, type, onSwitchType, onLoginSuccess }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let result;
      
      if (type === 'signup') {
        // Register new user
        result = await registerUser(
          formData.email,
          formData.password,
          formData.name,
          formData.phone
        );
      } else {
        // Login existing user
        result = await loginUser(formData.email, formData.password);
      }
      
      if (result.success) {
        // Reset form
        setFormData({
          name: '',
          email: '',
          password: '',
          phone: ''
        });
        
        // Call onLoginSuccess callback
        if (onLoginSuccess) {
          onLoginSuccess(result.user);
        }
        
        onClose();
        navigate('/dashboard');
      }
    } catch (error) {
      setError(error.message || 'An error occurred. Please try again.');
    }
    
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      password: '',
      phone: ''
    });
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal-container">
        <div className="auth-modal-content">
          <div className="auth-modal-header">
            <div className="auth-modal-close">
              <button className="close-btn" onClick={handleClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            <div className="auth-modal-title">
              <h2>{type === 'login' ? 'Welcome Back' : 'Create Account'}</h2>
              <p>
                {type === 'login' 
                  ? 'Sign in to your account to continue' 
                  : 'Join us to get started with our services'
                }
              </p>
            </div>
          </div>

          <div className="auth-modal-body">
            <div className="auth-divider">
              <span>Sign in with email</span>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              {type === 'signup' && (
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              )}
              
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  disabled={loading}
                />
              </div>
              
              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Password *"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="form-input"
                  minLength={6}
                  disabled={loading}
                />
              </div>

              {type === 'signup' && (
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number (Optional)"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              )}

              {error && (
                <div className="error-message">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                disabled={loading} 
                className={`submit-btn ${loading ? 'loading' : ''}`}
              >
                {loading ? (
                  <>
                    <div className="spinner"></div>
                    Processing...
                  </>
                ) : (
                  type === 'login' ? 'Sign In' : 'Create Account'
                )}
              </button>
            </form>

            <div className="auth-switch">
              <p>
                {type === 'login' ? "Don't have an account? " : "Already have an account? "}
                <button 
                  onClick={onSwitchType} 
                  className="switch-btn"
                  type="button"
                  disabled={loading}
                >
                  {type === 'login' ? 'Sign up' : 'Sign in'}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;